// ═══════════════════════════════════════════════════════════════════
//  modules/hub/api.js
//  Les appels du module Hub.
// ═══════════════════════════════════════════════════════════════════

import { API_BASE, authHeaders } from "../../socle/api";

async function lire(reponse) {
  const texte = await reponse.text();
  let corps = null;
  try { corps = texte ? JSON.parse(texte) : null; } catch { corps = { error: texte }; }
  if (!reponse.ok) throw new Error((corps && corps.error) || `Erreur ${reponse.status}`);
  return corps;
}

export function hubApi(token) {
  const h = authHeaders(token);
  return {
    etat: () => fetch(`${API_BASE}/api/hub/etat`, { headers: h }).then(lire),

    console: (commande) =>
      fetch(`${API_BASE}/api/hub/console`, {
        method: "POST", headers: h, body: JSON.stringify({ commande }),
      }).then(lire),
  };
}
